<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <div>广告编辑</div>
                </div>

                <div class="admin_main_block_right">
                    <div><el-button icon="el-icon-back" @click="$router.go(-1)">返回</el-button></div>
                </div>
            </div>

            <div class="admin_form_main">
                <el-form  label-width="100px" ref="info" :model="info">
                    <el-form-item label="姓名" prop="F_VR_XINGM" :rules="[{required:true,message:'姓名不能为空',trigger: 'blur' }]"><el-input placeholder="请输入姓名" v-model="info.F_VR_XINGM"></el-input></el-form-item>
                    <el-form-item label="微信号" prop="F_VR_WEIXH" :rules="[{required:true,message:'微信号不能为空',trigger: 'blur' }]"><el-input placeholder="请输入微信号" v-model="info.F_VR_WEIXH"></el-input></el-form-item>
                    <el-form-item label="电话" prop="F_VR_LIANXFS" :rules="[{required:true,message:'电话不能为空',trigger: 'blur' }]"><el-input placeholder="请输入电话" v-model="info.F_VR_LIANXFS"></el-input></el-form-item>


                    <el-form-item label="是否新线索" prop="F_TI_XIANS">
                        <el-select v-model="info.F_TI_XIANS" placeholder="选择是否新线索">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="2"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="线索来源" prop="F_VR_XIANSLY" :rules="[{required:true,message:'线索来源不能为空',trigger: 'blur' }]"><el-input placeholder="请输入线索来源" v-model="info.F_VR_XIANSLY"></el-input></el-form-item>

                    <el-form-item label="线索类型" prop="F_IN_XIANSLX">
                        <el-select v-model="info.F_IN_XIANSLX" placeholder="选择线索类型">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="广告线索" value="1"></el-option>
                            <el-option label="其他线索" value="2"></el-option>
                        </el-select>
                    </el-form-item>


                    <el-form-item label="招生老师" prop="F_IN_ZSLS_ID">
                        <el-select v-model="info.F_IN_ZSLS_ID" placeholder="请选择招生老师" @change="selectChange()">
                            <el-option label="请选择招生老师" :value="0"></el-option>
                            <el-option v-for="(v,k) in list" :label="v.F_VR_XINGM" :key="k" :value="v.F_IN_ID"></el-option>
                        </el-select>
                    </el-form-item>


                    <el-form-item>
                        <el-button type="primary" @click="submitForm('info')">提交</el-button>
                        <!-- <el-button @click="resetForm('info')">重置</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          edit_id:0,
          info:{
          },
          list:[],
          upload_headers:{},
      };
    },
    watch: {},
    computed: {},
    methods: {
        resetForm:function(e){
            this.$refs[e].resetFields();
        },
        submitForm:function(e){
            let _this = this;

            // 验证表单
            this.$refs[e].validate(function(res){
                if(res){
                    //  判断是Add 或者 Edit
                    let url = _this.$api.addXianslb;
                    if(_this.edit_id>0){
                        url = _this.$api.editXianslb+_this.edit_id;
                    }
                    // Http 请求
                    _this.$post(url,_this.info).then(function(res){
                        if(res.code == 200){
                            _this.$message.success("编辑成功");
                            _this.$router.go(-1);
                        }else{
                            _this.$message.error("编辑失败");
                        }
                    });
                }
            });
        },
        get_adv_info:function(){
            let _this = this;
            this.$get(this.$api.editXianslb+this.edit_id).then(function(res){
                _this.info = res.data.xianslb;
                _this.list = res.data.zsls;
            })

        },
        get_adv_list:function(){
            let _this = this;
            this.$get(this.$api.addXianslb).then(function(res){
                _this.list = res.data.zsls;
            })

        },
        selectChange:function(){
            this.$forceUpdate();
        },
        handleAvatarSuccess(res) {
            this.info.adv_image = res.data;
            this.$forceUpdate();
        },
    },
    created() {
        this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到

        if(!this.$isEmpty(this.$route.params.adv_position_id)){
            this.info.ap_id = this.$route.params.adv_position_id;
        }

        // 判断是否是编辑
        if(!this.$isEmpty(this.$route.params.id)){
            this.edit_id = this.$route.params.id;
        }

        if(this.edit_id>0){
            this.get_adv_info();
        }else{
            this.get_adv_list();
        }
        
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.line{text-align: center}
</style>